// extracted by mini-css-extract-plugin
export default {"root":"reservation_root__Zy1zO","iframe":"reservation_iframe__RDnLB","title":"reservation_title__9o+Bk"};